export default __webpack_public_path__ + "static/media/ch_4.0938fff0.mp3";